import { ref, onMounted, onUnmounted } from 'vue'
import {
  checkSecurity,
  enforceSecurity,
  startSecurityMonitoring,
  getCurrentSecurityStatus,
  type SecurityCheckResult
} from '@/utils/security'

/**
 * 安全相关的组合式函数
 */
export function useSecurity() {
  const securityStatus = ref<SecurityCheckResult | null>(null)
  const isSecure = ref(false)
  const isLoading = ref(true)
  let stopMonitoring: (() => void) | null = null

  /**
   * 执行安全检查
   */
  const performSecurityCheck = () => {
    try {
      const result = checkSecurity()
      securityStatus.value = result
      isSecure.value = result.isSecure
      isLoading.value = false

      return result
    } catch (error) {
      console.error('安全检查失败:', error)
      isLoading.value = false
      return null
    }
  }

  /**
   * 强制执行安全检查（阻止应用运行）
   */
  const enforceSecurityCheck = () => {
    enforceSecurity()
  }

  /**
   * 开始安全监控
   */
  const startMonitoring = (intervalMs: number = 30000) => {
    if (stopMonitoring) {
      stopMonitoring()
    }
    stopMonitoring = startSecurityMonitoring(intervalMs)
  }

  /**
   * 停止安全监控
   */
  const stopSecurityMonitoring = () => {
    if (stopMonitoring) {
      stopMonitoring()
      stopMonitoring = null
    }
  }

  /**
   * 获取当前安全状态
   */
  const getSecurityStatus = () => {
    const status = getCurrentSecurityStatus()
    securityStatus.value = status
    isSecure.value = status.isSecure
    return status
  }

  // 组件挂载时执行安全检查
  onMounted(() => {
    performSecurityCheck()
    startMonitoring(60000) // 每分钟检查一次
  })

  // 组件卸载时停止监控
  onUnmounted(() => {
    stopSecurityMonitoring()
  })

  return {
    // 状态
    securityStatus,
    isSecure,
    isLoading,

    // 方法
    performSecurityCheck,
    enforceSecurityCheck,
    startMonitoring,
    stopSecurityMonitoring,
    getSecurityStatus
  }
}
